// extracted by mini-css-extract-plugin
export default {"SubheadingContainer":"Subheading_SubheadingContainer__aXrmN","AddButton":"Subheading_AddButton__BHBAq"};